export const SET_RESOURCES_IN_HOUR = 'SET_RESOURCES_IN_HOUR';
export const SET_RESOURCES_IN_HOUR_ERROR = 'SET_RESOURCES_IN_HOUR_ERROR';
export const SET_LEVELS_IN_PLACE_BY_ENTITITES = 'SET_LEVELS_IN_PLACE_BY_ENTITITES';
export const SET_RES_IN_PLACE_BY_HOURS = 'SET_RES_IN_PLACE_BY_HOURS';
export const SET_RESOURCES_IN_HOUR_LOADING = 'SET_RESOURCES_IN_HOUR_LOADING';